// src/components/UserAudienceSection.jsx
import React from "react";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  LinearProgress,
  Stack,
} from "@mui/material";

const MetricRow = ({ label, percent, color }) => (
  <Box sx={{ mb: 1.5 }}>
    <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.5 }}>
      <Typography variant="body2" color="text.primary">
        {label}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {Number(percent).toFixed(1)}%
      </Typography>
    </Stack>
    <LinearProgress
      variant="determinate"
      value={percent}
      sx={{
        height: 10,
        borderRadius: 999,
        backgroundColor: "#EFF3FE",
        "& .MuiLinearProgress-bar": {
          borderRadius: 999,
          backgroundColor: color,  
        },
      }}
    />
  </Box>
);

const BAR_COLORS = [
  "#FC8347",
  "#2379BB",
  "#3D5EA1",
  "#5F4487",
  "#AC9DC1",
  "#FC4955",
  "#FDC03B",
];

const UserAudienceSection = ({
  topCountries = [],
  professions = [],
  ageGroups = [],
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        display: "grid",
        gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
        gap: 1,
        mt: 1,
        alignItems: "stretch",
      }}
    >
      <Box sx={{ gridColumn: "span 2", minWidth: 0 }}>
        <Card
        sx={{
          height: "100%",
          backgroundColor: "#fff",
        }}
      >
        <CardContent sx={{ height: "100%" }}>
          <Typography variant="subtitle1" sx={{ mb: 2, fontSize: 18}}>
            Top 5 Countries
          </Typography>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1.2fr",
                gap: 2,
              }}
            >
            {/* Lijevo: map box */}
            <Box
              sx={{
                height: 150,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 12,
              }}
            >
              <Box
                component="img"
                src="/world-map.png"
                alt="world map"
                sx={{ width: '100%', height: 125, mb: 1 }}
              />
            </Box>

            <Box>
              {topCountries.map((c, index) => (
                <MetricRow 
                  key={c.name} 
                  label={c.name} 
                  percent={c.percent} 
                  color={BAR_COLORS[(index + 1) % BAR_COLORS.length]}
                />
              ))}
            </Box>
          </Box>
          </CardContent>
        </Card>
      </Box>
      

      {/* 2) Profession */}
      <Box sx={{ gridColumn: "span 1", minWidth: 0 }}>
        <Card
          sx={{
            height: "100%",
            backgroundColor: "#fff",
          }}
        >
          <CardContent sx={{ height: "100%" }}>
            <Typography variant="subtitle1" sx={{ mb: 2, fontSize: 18}}>
              Profession
            </Typography>

            {professions.map((p, index) => (
              <MetricRow 
                key={p.name} 
                label={p.name} 
                percent={p.percent} 
                color={BAR_COLORS[(index + 1) % BAR_COLORS.length]} 
              />
            ))}
          </CardContent>
        </Card>
      </Box>

      {/* 3) Age Group */}
      <Box sx={{ gridColumn: "span 1", minWidth: 0 }}>
        <Card
          sx={{
            height: "100%",
            backgroundColor: "#fff",
          }}
        >
          <CardContent sx={{ height: "100%" }}>
            <Typography variant="subtitle1" sx={{ mb: 2, fontSize: 18 }}>
              Age Group
            </Typography>

            {ageGroups.map((g, index) => (
                <MetricRow 
                key={g.name} 
                label={g.name} 
                percent={g.percent}
                color={BAR_COLORS[index % BAR_COLORS.length]}
              />
            ))}
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default UserAudienceSection;
